import(/* webpackMode: "eager" */ "/vercel/path0/src/app/register/company/page.tsx");
